import { render, staticRenderFns } from "./FormPay.vue?vue&type=template&id=6a40ca0c&scoped=true&lang=pug"
import script from "./FormPay.vue?vue&type=script&lang=ts"
export * from "./FormPay.vue?vue&type=script&lang=ts"
import style0 from "./FormPay.vue?vue&type=style&index=0&id=6a40ca0c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40ca0c",
  null
  
)

export default component.exports